@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.legend-label {
  color: @insights-page--label--text-color;
}
